import React from 'react';
import './Dashboards.css';
import under from '../../../assets/img/under-construction.gif';

const Dashboards = () => (
  <div className="Dashboards">
    <img src={under} alt="" />
  </div>
);
export default Dashboards;
